import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { pluralReadableTypeName } from '@iotv/core-services';
import { GatewayClassName, getAllParentEdgeTypeMatrixEntries } from '@iotv/datamodel';
import { TabContext, TabList, TabPanel } from '@mui/lab';
import { Tab } from '@mui/material';
import { useEffect } from 'react';
import { v4 } from 'uuid';
import { ConsumerDao } from '../../../data/ConsumerDAO/consumerDAO';
import { useTabHandlerStringKeys } from '../../../hooks/useTabHandler';
import { getPlaceQuery } from '../../../QueryDefinitions/place';
import { AdjacentType, Severity } from '../../../types/AppTypes';
import { ObjectHeader } from '../../../v2/components/generic/ObjectView/ObjectHeader';
import { getListViewDefinition } from '../../factories/AttributeDefinitions';
import { AutoTab } from '../AutoTab';
import { getAreaViewDefinition, getPlaceViewDefinition } from '../viewDefinitions';
import { PlaceDetail } from './PlaceDetail';
const debug = process.env.REACT_APP_DEBUG && false;
export const PlaceView = (props) => {
    const { viewObject: viewObject, transactionFunctions, userFunctions, applicationData, contextCustomer } = props;
    const contextPlace = viewObject.matchedPrimary;
    /**
     * Gets all necessary things related to this place
     *
     * Then add to app state
     *
     * Runs on place change
     */
    const getPlaceContext = async (place) => {
        const { err, data } = await ConsumerDao.getGraphQueryRequestV2({ contextObjects: [place], query: getPlaceQuery() });
        if (err || !data) {
            userFunctions.setUserMessage({
                id: v4(),
                type: 'MessageBar',
                severity: Severity.error,
                label: 'PlaceView',
                content: err ? `${err.message}` : 'No response',
            });
        }
        if (data) {
            userFunctions.addObjectsToState(data.getContainedNodesAndEdges());
        }
    };
    useEffect(() => {
        if (contextPlace)
            getPlaceContext(contextPlace);
    }, [contextPlace?.sk]);
    debug && console.log('AreaView applicationData', applicationData);
    const parentTypes = getAllParentEdgeTypeMatrixEntries('Place');
    const filteredParentTypes = Object.keys(parentTypes).filter((t) => !['Property', 'Area', 'Place'].includes(t));
    const tabDefs = [
        { label: 'Details', value: 'Details', component: contextPlace ? _jsx(PlaceDetail, { ...props, contextPlace }) : _jsx(_Fragment, {}) },
        ...filteredParentTypes.map((parentType) => ({
            label: pluralReadableTypeName(parentType),
            value: pluralReadableTypeName(parentType),
            type: parentType,
            direction: AdjacentType.PARENT,
        })),
        { label: 'Gateways', value: 'Gateways', type: GatewayClassName, direction: AdjacentType.CHILD, viewDefinition: getListViewDefinition(GatewayClassName) },
    ];
    const tabKeyMap = Object.fromEntries(tabDefs.map((t) => [t.value, t]));
    const { state: [[value, setValue]], handlers: { handleTabChange }, } = useTabHandlerStringKeys(tabKeyMap);
    const typesToViewDefs = {
        Area: getAreaViewDefinition(),
        Place: getPlaceViewDefinition(),
    };
    return (_jsxs(_Fragment, { children: [_jsx(ObjectHeader, { vob: contextPlace }), _jsxs(TabContext, { value: value, children: [_jsx(TabList, { value, onChange: handleTabChange, children: tabDefs.map((t) => (_jsx(Tab, { label: t.label, value: t.value, sx: { textTransform: 'none' } }, t.label))) }), tabDefs.map((t) => {
                        const tabContent = contextPlace && contextCustomer && (_jsx(AutoTab, { tabDef: t,
                            mostProximateCustomer: contextCustomer,
                            contextCustomer,
                            contextObject: contextPlace,
                            viewObject,
                            userFunctions,
                            transactionFunctions,
                            viewDefinitionIn: typesToViewDefs[t.type ?? ''],
                            newObjectDefinition: typesToViewDefs[t.type ?? ''] }));
                        return (_jsx(TabPanel, { value: t.value, sx: { padding: 0, paddingBlockStart: 1 }, children: tabContent }, t.value));
                    })] })] }));
};
